import { useQuery } from "@tanstack/react-query";
import { useEndpoints } from "../api/ApiContext";
import type { TargetingCategory } from "../api/types";

// GET /v1/targeting/categories (targeting.go:35-66): one shared category
// vocabulary. Originally advertiser-only (0061); the web-reported fix
// alongside 0068's cursor round-trip made it readable by publisher
// sessions too (requirePartyType(pool, "advertiser", "publisher")), since
// migration 0066's declare_site_tools/set_inventory_exclusions validate a
// publisher's tool categories and exclusions against the exact same
// table. Both portals share this hook rather than each keeping its own
// copy of the fetch/cache.

export function useTargetingCategories() {
  const ep = useEndpoints();
  return useQuery({ queryKey: ["targeting-categories"], queryFn: () => ep.targeting.listCategories(), staleTime: 5 * 60_000 });
}

export function categoryLabel(categories: TargetingCategory[] | undefined, key: string): string {
  return categories?.find((c) => c.key === key)?.label ?? key;
}
